import PropTypes from 'prop-types';
import React, {Component} from 'react';
import CompanyDetails from './CompanyDetails';
import CompanySearch from './CompanySearch';

/**
 * Component class of CompanySearchApp
 */
export default class CompanySearchApp extends Component {
  /**
   * Creates a CompanySearchApp
   *
   * @param {Object} props - the property data
   */
  constructor(props) {
    super(props);
    this.state = {
      companyDetailsShown: false,
      companyDetails: null,
      companyList: null
    };
  }

  /**
   * Changes the components displayed
   *
   * @param {Object} eventObj - object containing company details
   * @param {Array} companies - companies list
   * @param {string} savedValue - saved search value
   */
  companyDetailsToggle = (eventObj, companies, savedValue) => {
    this.setState({
      companyDetailsShown: !this.state.companyDetailsShown,
      companyDetails: eventObj,
      companyList: companies,
      savedSearchValue: savedValue
    });
  };

  /**
   * Renders CompanySearchApp component
   *
   * @return {string} - company search application component to be rendered
   */
  render() {
    return (
      <div id='companies'>
        {!this.state.companyDetailsShown && (
          <div id='uid-search'>
            <CompanySearch
              submitHandler={this.props.submitHandler}
              onCompanyDetailsShown={this.companyDetailsToggle}
              companyList={this.state.companyList}
              savedSearchValue={this.state.savedSearchValue}
            />
          </div>
        )}
        {this.state.companyDetailsShown && (
          <div id='company-details'>
            <CompanyDetails
              onBackLinkClick={this.companyDetailsToggle}
              companyDetails={this.state.companyDetails}
              companyList={this.state.companyList}
              savedSearchValue={this.state.savedSearchValue}
            />
          </div>
        )}
      </div>
    );
  }
}

CompanySearchApp.propTypes = {
  submitHandler: PropTypes.func.isRequired
};
